import React from 'react';

import {useTranslation} from 'react-i18next';

import './GroupSchedulePageTop.scss';

// import {GREETING_SCHEDULE_MESSAGE, GREETING_SCHEDULE_MESSAGE_HINT,} from '../../../constants/translationLabels/common';
import SelectPlace from '../SelectPlace';
import SchedulePageForm from '../SchedulePageForm';

const GroupSchedulePageTop = (props) => {
    const { t } = useTranslation('common');
    const { handleSubmit, isManager } = props;

    return (
        <section className="schedule_page-container">
            <section className="schedule-form-buttons-container">
                <div className="schedule-filter-bar">
                    <SchedulePageForm onSubmit={handleSubmit} />
                </div>
                {isManager && <SelectPlace />}
            </section>
        </section>
    );
};

export default GroupSchedulePageTop;
